import { render, staticRenderFns } from "./TableHead.vue?vue&type=template&id=d65e9f0e&"
import script from "./TableHead.vue?vue&type=script&lang=js&"
export * from "./TableHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d65e9f0e')) {
      api.createRecord('d65e9f0e', component.options)
    } else {
      api.reload('d65e9f0e', component.options)
    }
    module.hot.accept("./TableHead.vue?vue&type=template&id=d65e9f0e&", function () {
      api.rerender('d65e9f0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/allergy-kpis/performance-evaluation/TableHead.vue"
export default component.exports